import React, { useEffect, useState } from "react";
import { Col, Dropdown } from "react-bootstrap";
import { useDimensions } from "../../../../Logic/Dimensions";
import CustomBreadcrumb from "../../../CustomBreadcrumb";
import Icon from "../../../Layouts/Icons";
import CommonModal from "../../../Modals/CommonModal";
import Style from "./../ContentHeader.module.scss";
import { useDispatch } from "react-redux";
import useGallery from "../../../../Logic/useGallery";
import { useGalleryTab } from "../../../../Logic/useGalleryTab";
import { useProjectSingle } from "../../../../Logic/useProjectSingle";
import { useParams } from "react-router-dom";
import ShareInfoPopup from "../../ProjectCard/ShareInfoPopup";
import { Formik } from "formik";
import InfiniteDotLoader from "../../../../utils/InfiniteDotLoader";
import {
  getFolderDetails,
  openMinimizedBox,
  uploadModalAction,
} from "../../../../store/slices/Gallery/gallerySlice";
import { updateUploadMode } from "../../../../store/slices/Gallery/fileUploadSlice";
import CustomPasswordInput from "../../../Layouts/CustomPasswordInput";
import Toggle from "../../../../utils/Toggle";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { toast } from "react-toastify";
import { useProjectGalleryHeader } from "./useProjectGalleryHeader";

const ProjectGalleryHeader = ({ isGrid, setIsGrid }) => {
  const {
    imagesLoading,
    handleGalleryTab,
    handleSelectedImageListViewToggle,
    handleDownloadUserSelectedFiles,
    handleDownloadWithExtention,
    handleDownloadImageId,
    handleEventShareInfoPopup,
    handleUpdateShareLinkStatus,
    shareNotificationSchema,
    isShowNotifyModal,
    setIsShowNotifyModal,
    shareNotificationSubmit,
    handleUnlock,
    capitalizeFirstLetter,
    handleClearSelectedImages,
  } = useGallery();
  const {
    handleClickTab,
    activeTab,
    isNavigating,
    activeTabLeft,
    activeTabWidth,
    selectedElement,
    suggestedElement,
    handlePreSelection,
    handleclosePreSelect,
    handleSelectAllImages,
    handledeSelectAllImages,
    uploadFPAModal,
    openDeletePopup,
    handleOrderChange,
    handlePaymentPage,
  } = useGalleryTab();

  const {
    selectedImageListView,
    status,
    currentFolderDetails,
    isClearing,
    allFolders,
    getCurrentProjectDetails,
    postShareStatus,
    notifyData,
    ulockStatus,
    unlockMessage,
    tokenDetails,
    sections,
    currentTab,
    project,
    setIsSelected,
    clearModal,
    setClearModal,
    handleClearModal,
  } = useProjectGalleryHeader();

  const handleClearModalSubmit = () => {
    handleClearSelectedImages();
    setClearModal(false);
  };
  const windowDimensions = useDimensions();
  const dispatch = useDispatch();
  const { handleGetEventShareInfoPopup } = useProjectSingle();
  const { projectID, folderID } = useParams();

  useEffect(() => {
    if (currentFolderDetails?.images_count == 0) {
      setIsSelected(false);
    } else if (currentFolderDetails?.images_count > 0) {
      setIsSelected(currentFolderDetails?.link_status === 1 ? true : false);
    }
  }, [currentFolderDetails?.link_status]);
  useEffect(() => {
    let obj = {
      id: folderID,
      url: "/album/get-album",
    };
    dispatch(getFolderDetails(obj));
  }, []);

  const onToggle = (e, value) => {
    handleUpdateShareLinkStatus(value == 1 ? 0 : 1);
  };
  const handleClickShareLink = (e) => {
    handleGetEventShareInfoPopup(folderID);
  };

  const handleURLShare = () => {
    if (
      allFolders?.list?.plan_payment_status != true ||
      sections["all"]?.data?.length == 0
    ) {
      toast.warning(
        allFolders?.list?.plan_payment_status != true
          ? "To explore this feature, you must complete your purchase."
          : sections["all"]?.data?.length == 0
          ? "You must have images for sharing."
          : "",
        {
          position: "top-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    }
  };

  const handleNotification = () => {
    let data = {
      project_id: projectID,
      album_id: folderID,
    };
    shareNotificationSubmit(data);
  };

  return (
    <>
      {windowDimensions.width > 992 ? (
        <>
          <CustomBreadcrumb
            levels={[
              { title: "Project", path: "/dashboard/project" },
              {
                title:
                  getCurrentProjectDetails?.currentPageDetails?.name?.length >
                  15
                    ? getCurrentProjectDetails?.currentPageDetails?.name?.slice(
                        0,
                        15
                      ) + "..."
                    : getCurrentProjectDetails?.currentPageDetails?.name,
                path: `/dashboard/project/${getCurrentProjectDetails?.currentPageDetails?.id}`,
              },
              {
                title:
                  allFolders?.editFolder?.details?.name?.length > 15
                    ? allFolders?.editFolder?.details?.name?.slice(0, 15) +
                      "..."
                    : allFolders?.editFolder?.details?.name,
                path: "",
              },
            ]}
          />
        </>
      ) : (
        <></>
      )}

      <div className={Style.ContentHeader__wrap}>
        <div className={Style.ContentHeader__left}>
          {allFolders?.editFolder?.details?.name ? (
            <h1 className={Style.ContentHeader__title}>
              {allFolders?.editFolder?.details?.name?.length > 15
                ? allFolders?.editFolder?.details?.name?.slice(0, 15) + "..."
                : allFolders?.editFolder?.details?.name}
            </h1>
          ) : (
            <span>
              <ShimmerThumbnail height={30} rounded width={200} />
            </span>
          )}

          <ul className={Style.ContentHeader__navList}>
            <li
              className={activeTab === "all" ? "tabActive" : ""}
              style={{ pointerEvents: isNavigating ? "none" : "auto" }}
              onClick={(e) => {
                if (status !== "loading") {
                  handleClickTab(e, "all");
                }
              }}
            >
              All {windowDimensions.width < 1800 ? "" : "Photos"} (
              {currentFolderDetails?.images_count ?? 0})
            </li>
            <li
              ref={suggestedElement}
              className={activeTab === "suggested" ? "tabActive" : ""}
              style={{ pointerEvents: isNavigating ? "none" : "auto" }}
              onClick={(e) => {
                if (status !== "loading") {
                  handleClickTab(e, "suggested");
                }
              }}
            >
              Suggested {windowDimensions.width < 1800 ? "" : "Photos"} (
              {currentFolderDetails?.suggested_images_count
                ? currentFolderDetails?.suggested_images_count
                : currentFolderDetails?.suggested_images_count == NaN
                ? 0
                : 0}
              )
            </li>
            <li
              ref={selectedElement}
              className={activeTab === "selected" ? "tabActive" : ""}
              style={{ pointerEvents: isNavigating ? "none" : "auto" }}
              onClick={(e) => {
                if (status !== "loading") {
                  handleClickTab(e, "selected");
                }
              }}
            >
              Selected {windowDimensions.width < 1800 ? "" : "Photos"} (
              {currentFolderDetails?.selected_images_count ?? 0})
            </li>
            <li
              className={Style.activeTab__indicator}
              style={{
                transform: `translateX(${activeTabLeft}px)`,
                width: `${activeTabWidth}px`,
              }}
            ></li>
          </ul>
        </div>
        <div className={Style.ContentHeader__right}>
          {project.currentTab !== "completedTab" && (
            <ul
              className={`${Style.ContentHeader__actionsBtn} ${
                !sections[currentTab]?.currentAction?.preSelect
                  ? Style.ContentHeader__mainBtn
                  : ""
              }`}
            >
              {activeTab === "all" || activeTab === "suggested" ? (
                <>
                  {!sections[currentTab]?.currentAction?.preSelect && ( // CHECKING DATA LENGTH > 0
                    <>
                      {allFolders.list.plan_payment_status == 0 && (
                        <li>
                          <button
                            className="btn btn-border-grey btn-sm btn-theme btn-bank-cards"
                            onClick={handlePaymentPage}
                          >
                            {windowDimensions.width >= 1280 ? (
                              <>Pay Now</>
                            ) : (
                              <Icon
                                color={"currentColor"}
                                size={21}
                                icon={"bank-cards"}
                              />
                            )}
                          </button>
                        </li>
                      )}

                      <li>
                        <button
                          className="btn btn-border-grey btn-sm btn-theme"
                          onClick={() => {
                            dispatch(uploadModalAction(true));
                            dispatch(openMinimizedBox(false));
                            dispatch(updateUploadMode("photoFind"));
                          }}
                        >
                          {windowDimensions.width >= 1200 ? (
                            <>Upload Photos</>
                          ) : (
                            <Icon
                              color={"currentColor"}
                              size={16}
                              icon={"icon-plus"}
                            />
                          )}
                        </button>
                      </li>
                      {currentTab !== "all" && (
                        <li>
                          <div
                            className={Style.shared_url_wrap}
                            onClick={handleURLShare}
                          >
                            <span>Shared URL</span>
                            <Toggle
                              checked={
                                currentFolderDetails?.link_status == 1
                                  ? true
                                  : false
                              }
                              text=""
                              size={""}
                              disabled={
                                !allFolders?.list?.plan_payment_status ||
                                sections["all"]?.data?.length == 0
                              }
                              onChange={(e) =>
                                onToggle(e, currentFolderDetails?.link_status)
                              }
                              offstyle="btn-danger"
                              onstyle="btn-success"
                            />
                          </div>
                        </li>
                      )}

                      {currentTab !== "all" && (
                        <>
                          <li>
                            <button
                              disabled={
                                allFolders?.list.plan_payment_status !== 1 ||
                                sections["all"]?.data?.length == 0
                              }
                              className="btn btn-border-grey btn-sm btn-theme"
                              onClick={() => {
                                handleGetEventShareInfoPopup(folderID);
                              }}
                            >
                              {windowDimensions.width >= 1600 ? (
                                <>Share </>
                              ) : (
                                <Icon
                                  color={"currentColor"}
                                  size={16}
                                  icon={"share2"}
                                  className="me-0"
                                />
                              )}
                            </button>
                          </li>
                          <li>
                            {windowDimensions.width < 1200 ||
                            windowDimensions.width > 1600 ? (
                              <button
                                disabled={
                                  allFolders?.list?.plan_payment_status !== 1 ||
                                  currentFolderDetails?.mail_status !== null ||
                                  postShareStatus === "loading"
                                }
                                onClick={() => handleNotification()}
                                className="btn btn-border-grey btn-sm btn-theme"
                              >
                                {postShareStatus === "loading" ? (
                                  <InfiniteDotLoader />
                                ) : (
                                  "Inform Client"
                                )}
                              </button>
                            ) : null}
                          </li>
                        </>
                      )}
                    </>
                  )}
                  {sections[currentTab]?.currentAction?.preSelect != true &&
                    tokenDetails?.code != undefined && (
                      <>
                        <li>
                          <button
                            disabled={
                              allFolders?.list?.plan_payment_status !== 1
                            }
                            className="btn btn-border-grey btn-sm btn-theme"
                            onClick={() => {
                              uploadFPAModal(true);
                              dispatch(updateUploadMode("FPA"));
                            }}
                          >
                            {windowDimensions.width >= 1200 ? (
                              <>Upload to FPA</>
                            ) : (
                              <Icon
                                color={"currentColor"}
                                size={16}
                                icon={"upload2"}
                              />
                            )}
                          </button>
                        </li>
                      </>
                    )}
                  {/* DELETE BUTTON */}
                  {sections[currentTab]?.currentAction?.preSelect &&
                    sections[currentTab] != undefined &&
                    sections[currentTab]?.selectedImages?.length > 0 && (
                      <li>
                        <button
                          className="btn btn-border-grey btn-sm"
                          onClick={() => {
                            openDeletePopup(true);
                          }}
                        >
                          <Icon size={16} icon={"icon-trash"} />
                          {windowDimensions.width >= 1280 && <>Delete</>}
                        </button>
                      </li>
                    )}
                  {/* PRE-STATE ENABLE OR DISABLE BUTTON */}
                  <li>
                    {!sections[currentTab]?.currentAction?.preSelect &&
                      sections[currentTab] != undefined &&
                      sections[currentTab]["data"]?.length > 0 && (
                        <button
                          disabled={
                            imagesLoading ||
                            (sections[currentTab] != undefined &&
                              sections[currentTab]["data"]?.length > 0)
                              ? false
                              : true
                          }
                          className="btn btn-border-grey btn-sm"
                          onClick={() => {
                            if (!imagesLoading) {
                              handlePreSelection();
                            } else {
                              return;
                            }
                          }}
                        >
                          {imagesLoading && currentTab !== "suggested" ? (
                            <InfiniteDotLoader />
                          ) : (
                            <>
                              <Icon
                                size={18}
                                icon={
                                  !sections[currentTab]?.currentAction
                                    ?.preSelect
                                    ? "icon-unchecked"
                                    : "icon-checked"
                                }
                              />
                              {windowDimensions.width >= 1200 && <>Select</>}
                            </>
                          )}
                        </button>
                      )}

                    {/* DE-SELECT AND SELECT ALL BUTTONS */}

                    {sections[currentTab]?.currentAction?.preSelect && (
                      <button
                        className="btn btn-border-grey btn-sm"
                        onClick={() => {
                          if (
                            sections[currentTab]?.selectedImages?.length ===
                            sections[currentTab]?.data?.length
                          ) {
                            handledeSelectAllImages();
                          } else {
                            handleSelectAllImages();
                          }
                        }}
                      >
                        <Icon
                          size={18}
                          icon={
                            sections[currentTab]?.selectedImages?.length !==
                            sections[currentTab]?.data?.length
                              ? "icon-unchecked"
                              : "icon-checked"
                          }
                        />

                        {windowDimensions.width >= 1200 && (
                          <>
                            {sections[currentTab]?.selectedImages?.length ===
                            sections[currentTab]?.data?.length
                              ? "Deselect all"
                              : "Select all"}
                          </>
                        )}
                      </button>
                    )}
                  </li>
                  {!sections[currentTab]?.currentAction?.preSelect &&
                    sections[currentTab] != undefined &&
                    sections[currentTab]["data"]?.length > 0 &&
                    sections[currentTab]["data"]?.length != 1 && (
                      <li>
                        <Dropdown
                          className={`${Style.ContentHeader__filter_dropdown}`}
                        >
                          <Dropdown.Toggle className="btn btn-border-grey btn-sm">
                            {sections[currentTab]?.["order"] === undefined ||
                            sections[currentTab]?.["order"] === "desc"
                              ? "Latest"
                              : "Oldest"}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              disabled={
                                sections[currentTab]?.["order"] === undefined ||
                                sections[currentTab]?.["order"] === "desc"
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                handleOrderChange("desc");
                              }}
                            >
                              Latest
                            </Dropdown.Item>

                            <Dropdown.Item
                              disabled={
                                sections[currentTab]?.["order"] === "asc"
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                handleOrderChange("asc");
                              }}
                            >
                              Oldest
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>
                    )}
                  {!sections[currentTab]?.currentAction?.preSelect &&
                    windowDimensions.width < 1600 &&
                    windowDimensions.width > 1200 &&
                    currentTab === "suggested" && (
                      <li>
                        <Dropdown className="options-dropdown">
                          <Dropdown.Toggle className="btn btn-border-grey btn-sm btn-three-dots correntColor">
                            <Icon
                              color="currentColor"
                              size={16}
                              icon="icon-three-dots"
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              className="mt-2"
                              onClick={() => handleNotification()}
                              disabled={
                                allFolders?.list?.plan_payment_status !== 1 ||
                                currentFolderDetails?.mail_status !== null ||
                                postShareStatus === "loading"
                              }
                            >
                              {postShareStatus === "loading" ? (
                                <InfiniteDotLoader />
                              ) : (
                                "Inform Client"
                              )}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>
                    )}
                  {/* CLOSE BUTTON  */}
                  {sections[currentTab]?.currentAction?.preSelect && (
                    <li>
                      <button
                        className="btn btn-border-grey btn-sm btn-three-dots"
                        onClick={() => {
                          handleclosePreSelect();
                        }}
                      >
                        <Icon color={""} size={14} icon={"icon-close"} />
                      </button>
                    </li>
                  )}
                </>
              ) : (
                <>
                  {sections[currentTab]?.data?.length > 0 &&
                    currentTab === "selected" && (
                      <>
                        {/* <li>
                          <button
                            disabled={
                              allFolders?.list?.plan_payment_status !== 1
                            }
                            // onClick={() => handleLockButton()}
                            className="btn btn-border-grey btn-sm btn-theme"
                          >
                            {notifyData === null
                              ? "Notify"
                              : notifyData == 1 ||
                                unlockMessage?.status === false
                              ? "Unlock"
                              : ulockStatus === "loading"
                              ? "unlocking..."
                              : "Lock"}
                          </button>
                        </li> */}

                        <li>
                          <button
                            disabled={
                              allFolders?.list?.plan_payment_status !== 1
                            }
                            className="btn btn-border-grey btn-sm btn-theme"
                            onClick={() => {
                              uploadFPAModal(true);
                              dispatch(updateUploadMode("FPA"));
                            }}
                          >
                            {windowDimensions.width >= 1200 ? (
                              <>Upload to FPA</>
                            ) : (
                              <Icon
                                color={"currentColor"}
                                size={16}
                                icon={"upload2"}
                              />
                            )}
                          </button>
                        </li>
                        {windowDimensions.width >= 1560 ? (
                          <>
                            <li>
                              <button
                                className="btn btn-primary btn-sm btn-theme"
                                onClick={() => {
                                  handleDownloadUserSelectedFiles(true);
                                }}
                              >
                                {windowDimensions.width >= 1280 ? (
                                  <>Download</>
                                ) : (
                                  <Icon
                                    color={"#fff"}
                                    size={16}
                                    icon={"icon-download"}
                                  />
                                )}
                              </button>
                            </li>
                            <li>
                              <button
                                className="btn btn-primary btn-sm btn-theme"
                                onClick={() => {
                                  handleDownloadImageId();
                                }}
                              >
                                <>Download Only ID</>
                              </button>
                            </li>
                            <li>
                              <button
                                className="btn btn-primary btn-sm btn-theme"
                                onClick={() => {
                                  handleDownloadWithExtention();
                                }}
                              >
                                Download With Extenstion
                              </button>
                            </li>
                          </>
                        ) : (
                          <Dropdown
                            id="download_dropdown"
                            style={{ marginLeft: "6px" }}
                          >
                            <Dropdown.Toggle className="btn btn-border-grey btn-sm  correntColor ">
                              Download
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item>
                                <button
                                  className="btn btn-sm  correntColor "
                                  onClick={() => {
                                    handleDownloadImageId();
                                  }}
                                >
                                  <>Download Only ID</>
                                </button>
                              </Dropdown.Item>
                              <Dropdown.Item>
                                {" "}
                                <button
                                  className="btn btn-sm  correntColor "
                                  onClick={() => {
                                    handleDownloadWithExtention();
                                  }}
                                >
                                  Download With Extenstion
                                </button>
                              </Dropdown.Item>
                              <Dropdown.Item>
                                <button
                                  className="btn btn-sm  correntColor "
                                  onClick={() => {
                                    handleDownloadUserSelectedFiles(true);
                                  }}
                                >
                                  <>Download</>
                                </button>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </>
                    )}
                  {currentTab === "selected" && (
                    <li>
                      <button
                        disabled={
                          sections[currentTab]?.data?.length === 0
                            ? true
                            : false
                        }
                        className="btn btn-border-grey btn-sm"
                        onClick={() =>
                          handleSelectedImageListViewToggle(
                            !selectedImageListView
                          )
                        }
                      >
                        <Icon
                          size={18}
                          icon={
                            !selectedImageListView ? "icon-list" : "icon-grid"
                          }
                        />
                        {windowDimensions.width >= 1280 && (
                          <>{!selectedImageListView ? "List" : "Grid"}</>
                        )}
                      </button>
                    </li>
                  )}
                </>
              )}
            </ul>
          )}
        </div>
        {activeTab === "selectedTab" && (
          <div className={Style.ContentHeader__lastUpdatedDate}>
            Last updated on: 21-11-2022
          </div>
        )}
      </div>

      {/* Share info Popup */}

      <ShareInfoPopup
        openShareModal={allFolders?.eventInfo?.shareInfo?.status === true}
        setOpenShareModal={handleEventShareInfoPopup}
      />
    </>
  );
};

export default ProjectGalleryHeader;
